import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ImgProfileNewbie from "../medias/femme-cap_U1RVRElPIEtBVCA0MDYtMjk copier.jpg";
import ImgProfileNewbieOver from "../medias/femme-cap_over.jpg";
import ImgProfileCompétition from "../medias/vecteezy_roadbike-flat-icon_5742035 copier.jpg";
import ImgProfileCompétitionOver from "../medias/vecteezy_roadbike_over.jpg";
import ImgProfileTogether from "../medias/Freestyle_Swimming_Stroke copier.jpg";
import ImgProfileTogetherOver from "../medias/Freestyle_Swimming_Stroke_over.jpg";
import ImgProfileNature from "../medias/Bike Trail Sport copier.jpg";
import ImgProfileNatureOver from "../medias/Bike Trail Sport_over.jpg";
//import PropTypes from "prop-types";

//ProfileSelector.propTypes = {};

const ProfileSelector = () => {
  const [over1, setOver1] = useState(false);
  const [over2, setOver2] = useState(false);
  const [over3, setOver3] = useState(false);
  const [over4, setOver4] = useState(false);
  return (
    <section className="my-5">
      <div className="row mb-2">
        <div className="col-12 text-center">
          <h4 className="font-italic text-warning">RECHERCHE RAPIDE</h4>
        </div>
      </div>

      <div className="row border-bottom pb-3">
        <div className="col-md-3">
          <div className="row">
            <div className="col-6 col-md-12 px-0 mx-0">
              <Link
                onMouseOver={() => setOver1(true)}
                onMouseOut={() => setOver1(false)}
                to="/triathlon/decouverte"
              >
                <img
                  src={over1 ? ImgProfileNewbieOver : ImgProfileNewbie}
                  alt="Profil débutant"
                  className="d-block mx-auto w-50"
                />
              </Link>
            </div>
            <div className="col-6  col-md-12">
              <p className="text-center my-2">
                Découvrir
                <br />
                le triathlon
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="row">
            <div className="col-6 col-md-12 px-0">
              <Link
                onMouseOver={() => setOver2(true)}
                onMouseOut={() => setOver2(false)}
                to="/triathlon/performance"
              >
                <img
                  src={
                    over2 ? ImgProfileCompétitionOver : ImgProfileCompétition
                  }
                  alt="Profil performance"
                  className="d-block mx-auto w-50"
                />
              </Link>
            </div>
            <div className="col-6  col-md-12">
              <p className="text-center my-2">
                Les compétitions :
                <br />
                vitesse ou difficulté&nbsp;?
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="row">
            <div className="col-6 col-md-12 px-0">
              <Link
                onMouseOver={() => setOver3(true)}
                onMouseOut={() => setOver3(false)}
                to="/triathlon/dompter"
              >
                <img
                  src={over3 ? ImgProfileTogetherOver : ImgProfileTogether}
                  alt="Profil sécurité"
                  className="d-block mx-auto w-50"
                />
              </Link>
            </div>
            <div className="col-6  col-md-12">
              <p className="text-center my-2">
                Épreuves :
                <br /> gagner en sérénité
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="row">
            <div className="col-6 col-md-12 px-0">
              <Link
                onMouseOver={() => setOver4(true)}
                onMouseOut={() => setOver4(false)}
                to="/triathlon/nature"
              >
                <img
                  src={over4 ? ImgProfileNatureOver : ImgProfileNature}
                  alt="Profil nature"
                  className="d-block mx-auto w-50"
                />
              </Link>
            </div>
            <div className="col-6  col-md-12">
              <p className="text-center my-2">
                Les cross-triathlons
                <br />à pratiquer en nature
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileSelector;
